import { Status } from "./Status";

export class DisposalLineItemStatusSmartEnum {
    static Draft = new Status("Draft", 1, "pill--yellow");
    static ToPick = new Status("To Pick", 2, "pill--orange");
    static Cancelled = new Status("Cancelled", 3, "pill--red");
    static Queued = new Status("Queued", 4, "pill--blue");
    static Disposed = new Status("Disposed", 5, "pill--green");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "DisposalLineItemStatusSmartEnum";
    }
}
